import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const Hash02Icon = (props?: SvgProps) => (
  <svg
    height="20"
    width="20"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M13.7614 2.36339C13.837 1.9095 14.2662 1.60265 14.7201 1.67817C15.1739 1.75382 15.4808 2.18295 15.4053 2.63683L14.8722 5.83345H17.0833C17.5436 5.83345 17.9167 6.20654 17.9167 6.66678C17.9167 7.12702 17.5436 7.50011 17.0833 7.50011H14.5947L13.7614 12.5001H16.25C16.7102 12.5001 17.0833 12.8732 17.0833 13.3334C17.0833 13.7937 16.7102 14.1668 16.25 14.1668H13.4839L12.9053 17.6368C12.8296 18.0907 12.4005 18.3975 11.9466 18.3221C11.4927 18.2464 11.1859 17.8173 11.2614 17.3634L11.7944 14.1668H6.81722L6.23861 17.6368C6.16296 18.0907 5.73382 18.3975 5.27995 18.3221C4.82606 18.2464 4.51923 17.8173 4.59473 17.3634L5.12777 14.1668H2.08333C1.6231 14.1668 1.25 13.7937 1.25 13.3334C1.25 12.8732 1.6231 12.5001 2.08333 12.5001H5.40527L6.23861 7.50011H2.91667C2.45643 7.50011 2.08333 7.12702 2.08333 6.66678C2.08333 6.20654 2.45643 5.83345 2.91667 5.83345H6.51611L7.09473 2.36339C7.17037 1.9095 7.5995 1.60267 8.05339 1.67817C8.50727 1.75382 8.81411 2.18295 8.73861 2.63683L8.20557 5.83345H13.1828L13.7614 2.36339ZM7.09473 12.5001H12.0719L12.9053 7.50011H7.92806L7.09473 12.5001Z"
      fill="#474A53"
    />
  </svg>
)
